<mat-card class="card-chart-card" appearance="outlined">
  <div class="card-chart-header">
    @if (chartInfo.iconName) {
      <mat-icon class="card-chart-icon" color="primary">{{ chartInfo.iconName }}</mat-icon>
    }
    <span class="card-chart-title">{{ chartInfo.title }}</span>
    @if (multiKpi) {
      <span class="card-chart-toolbar-actions">
        <mat-form-field class="kpi-filter-ff" appearance="outline">
          <mat-select
            class="kpi-select"
            placeholder=""
            [value]="selectedKpi"
            (selectionChange)="onKpiSelected($event.value)"
            >
            @for (kpi of outboundKpis; track kpi) {
              <mat-option
                class="text-muted"
                [value]="kpi"
                >
                {{ kpi.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field class="date-filter-ff" appearance="outline">
          <mat-select
            class="chip-select"
            placeholder=""
            [value]="selectedDate"
            (selectionChange)="onDateChanged($event.value)"
            >
            @for (date of availableDates; track date) {
              <mat-option
                class="text-muted"
                [value]="date"
                >
                {{ date.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </span>
    }
  </div>
  <mat-card-content>
    <div class="card-chart-content-flex">
      <canvas
        baseChart
        style="height: 35vh; max-height: 35vh"
        [type]="chartInfo.type"
        [data]="chartInfo.data"
        [options]="chartInfo.options"
        >
      </canvas>
    </div>
    <!--
    // TODO: these options where removed from the chart
    [colors]="chartInfo.colors"
    -->
  </mat-card-content>
</mat-card>
